export enum OperationExecutionStatus {
  FAILED = 'failed',
  IN_PROGRESS = 'in progress',
  OPERATION_COMPLETE = 'operation complete',
  QUEUED = 'queued',
  STEP_COMPLETE = 'step complete'
}
